export const PERSISTENT_AI_DISCLOSURE = 'You are chatting with an AI assistant. Answers provided may be inaccurate; please consult your coach or mentor for verification if you are unsure.';

export const GENERATED_CONTENT_DISCLOSURE = 'This content was generated by AI and may be inaccurate. Please consult your coach or mentor for verification if you are unsure.';

export const AI_COMPETENCY_SELECTION_DISCLOSURE = 'Competencies have been selected below by our AI based on your learning reflection. Please ensure that they are accurate before proceeding.';
